<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Músicas de Espera</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataMusicaEmEspera"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/cadastro/espera/criar"
              target="_blank"
              @click="handleGoToNewMusicaEmEspera"
            >
              Criar Música de Espera
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom v-if="item._id !== 'default'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/espera/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item._id !== 'default'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Músicas de Espera: {{ qtdMusicaEmEspera }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import musicasEmEsperaStore from '../_store'
import musicaEmEsperaHttpService from '../_services/musicaEmEsperaHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Classe',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataMusicaEmEspera: [{ description: 'default', _id: 'default' }],
    snackbar: true,
  }),

  computed: {
    ...mapGetters('musicaEmEsperaHomeModulePABXStore', ['getMusicasEmEspera']),

    numberOfPages() {
      return Math.ceil(this.dataMusicaEmEspera.length / this.itemsPerPage)
    },
    qtdMusicaEmEspera() {
      return this.dataMusicaEmEspera.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'musicaEmEsperaHomeModulePABXStore', musicasEmEsperaStore)

    await this.listarMusicasEmEspera()
    this.dataMusicaEmEspera = [...this.getMusicasEmEspera]

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('musicaEmEsperaHomeModulePABXStore', ['listarMusicasEmEspera']),

    handleGoToNewMusicaEmEspera(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewMusicaEmEspera = this.$router.resolve({ name: 'Espera/criar' })
        window.open(goToNewMusicaEmEspera.href, '_blank')
      } else {
        this.$router.push({ name: 'Espera/criar' })
      }
    },

    atualizar(event, item) {
      if (item.item._id !== 'default') {
        if (event.metaKey || event.ctrlKey) {
          const updatePath = this.$router.resolve(`espera/atualizar/${item.item._id}`)
          window.open(updatePath.href, '_blank')
        } else {
          this.$router.push(`espera/atualizar/${item.item._id}`)
        }
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`espera/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`espera/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover a classe "${item.description}"?`)
      if (resultado) {
        try {
          await musicaEmEsperaHttpService.deleteMusicaEmEspera(item._id)
          this.dataMusicaEmEspera = this.dataMusicaEmEspera.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
